import _ from "lodash";
import React from "react";
import { withRouter } from "react-router-dom";
import useAdminDataManager from "../../../hooks/useAdminDataManager";
import { createAndInviteParticipant, fetchParticipants, updateParticipant } from "../../../api/participants";
import { Loader, Section } from "../../../components/styled";
import { InviteParticipantButton, ParticipantDialog, ParticipantList } from "../../../components/pages/participants";

export default withRouter(({ history }) => {
  const { manage, state } = useAdminDataManager(fetchParticipants, createAndInviteParticipant, updateParticipant, {archived: true});
  const {
    cancelEdit, startEdit, startCreate, saveData,
  } = manage;

  const { currentMode, items, targetItem } = state;
  const renderByMode = {
    loading: () => <Loader />,
    listing: () => (
      <>
        <Section>
          <ParticipantList participants={_.orderBy(items, org => (org.name || "").toUpperCase())} onEdit={startEdit} history={history} isAdmin={true} />
        </Section>
      </>
    ),
  };
  return (
    <>
      <h2> Archived Participants </h2>
      {renderByMode[currentMode]()}
    </>
  );
});
